import type { Droits } from "../components/Profile/types";

export type ProfileRights = Record<number, Droits>;

export const READ_ONLY_MESSAGE = "Lecture seule — droits en écriture requis";

// Fail-open: only an explicit RO entry blocks writes. Unknown ids / undefined
// (non-profile-scoped usage, or rights not yet loaded) are treated as writable;
// the backend remains the real gate.
export function profileCanWrite(
  rights: ProfileRights,
  profileId?: number | null,
): boolean {
  if (profileId == null) return true;
  return rights[profileId] !== "RO";
}

export function buildProfileRights(
  profiles: { id: number; droits?: Droits }[],
): ProfileRights {
  const rights: ProfileRights = {};
  for (const profile of profiles) {
    if (profile.droits) {
      rights[profile.id] = profile.droits;
    }
  }
  return rights;
}
